// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavMenu_nav-menu__k2Ulv {
  position: fixed;
  width: 300px;
  height: 100vh;
  padding: 24px;
  background: #000054;
  color: #fff;
}

.NavMenu_items__Avh8L {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: calc(100% - 44px);
  margin: 0;
  padding: 0;
}
.NavMenu_items__Avh8L.NavMenu_colabel__bLn-f {
  height: calc(100% - 44px - 20px);
}

.NavMenu_item__pv7QC {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 8px;
}
.NavMenu_item__pv7QC:hover {
  background: #00007a;
}
.NavMenu_item__pv7QC:not(:last-child) {
  margin-bottom: 16px;
}
.NavMenu_item-title__FkWi1 {
  flex: 1 1;
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
}
.NavMenu_item-title__FkWi1.NavMenu_is-active__r3kd9 {
  font-weight: 600;
}
.NavMenu_item-title__FkWi1 svg {
  margin-right: 12px;
  margin-bottom: 2px;
  vertical-align: middle;
}
.NavMenu_item-title__FkWi1 a {
  width: 100%;
  height: 100%;
  display: block;
}
.NavMenu_item-title__FkWi1 a:hover {
  text-decoration: none;
}

.NavMenu_sign-out__1V6AD {
  height: 44px;
}

.NavMenu_powered__qkk61 {
  display: block;
  margin: -10px 0 0 10px;
}

@media screen and (max-width: 900px) {
  .NavMenu_nav-menu__k2Ulv {
    width: 250px;
  }
}
@media screen and (max-width: 600px) {
  .NavMenu_nav-menu__k2Ulv {
    z-index: 5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: calc(100% - 77px);
    padding: 24px 24px 24px 52px;
  }
  .NavMenu_header__kkoKp {
    position: absolute;
    top: 0;
    left: 0;
  }
  .NavMenu_items__Avh8L {
    height: initial;
    margin-bottom: 20px;
  }
  .NavMenu_item__pv7QC:not(:last-child) {
    margin-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NavMenu/NavMenu.module.scss","webpack://./src/styles/sizes.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAKA;EACE,eAAA;EACA,YCHe;EDIf,aAAA;EACA,aAAA;EACA,mBEFS;EFGT,WAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;AAEF;AAAE;EACE,gCAAA;AAEJ;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AACF;AACE;EACE,mBE5BO;AF6BX;AAEE;EACE,mBAAA;AAAJ;AAGE;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAII;EACE,kBAAA;EACA,kBAAA;EACA,sBAAA;AAFN;AAKI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAHN;AAKM;EACE,qBAAA;AAHR;;AASA;EACE,YApEgB;AA8DlB;;AASA;EACE,cAAA;EACA,sBAAA;AANF;;AASA;EACE;IACE,YC5EgB;EDsElB;AACF;AASA;EACE;IACE,UAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,yBAAA;IACA,4BAAA;EAPF;EAUA;IACE,kBAAA;IACA,MAAA;IACA,OAAA;EARF;EAWA;IACE,eAAA;IACA,mBAAA;EATF;EAaE;IACE,mBAAA;EAXJ;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n$sign-out-height: 44px;\n\n.nav-menu {\n  position: fixed;\n  width: sizes.$nav-menu-width;\n  height: 100vh;\n  padding: 24px;\n  background: colors.$primary9;\n  color: #fff;\n}\n\n.items {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: calc(100% - $sign-out-height);\n  margin: 0;\n  padding: 0;\n\n  &.colabel{\n    height: calc(100% - $sign-out-height - 20px);\n  }\n}\n\n.item {\n  display: flex;\n  align-items: center;\n  padding: 4px 8px;\n  cursor: pointer;\n  border-radius: 8px;\n\n  &:hover {\n    background: colors.$primary8;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: 16px;\n  }\n\n  &-title {\n    flex: 1;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n\n    &.is-active {\n      font-weight: 600;\n    }\n\n    svg{\n      margin-right: 12px;\n      margin-bottom: 2px;\n      vertical-align: middle;\n    }\n\n    a {\n      width: 100%;\n      height: 100%;\n      display: block;\n\n      &:hover {\n        text-decoration: none;\n      }\n    }\n  }\n}\n\n.sign-out {\n  height: $sign-out-height;\n}\n\n.powered{\n  display: block;\n  margin: -10px 0 0 10px;\n}\n\n@media screen and (max-width: sizes.$breakpoint-md) {\n  .nav-menu {\n    width: sizes.$nav-menu-width-md;\n  }\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .nav-menu {\n    z-index: 5;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: calc(100% - sizes.$nav-menu-mobile-height);\n    padding: 24px 24px 24px 52px;\n  }\n\n  .header {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n\n  .items {\n    height: initial;\n    margin-bottom: 20px;\n  }\n\n  .item {\n    &:not(:last-child) {\n      margin-bottom: 20px;\n    }\n  }\n}\n","$breakpoint-sm: 600px;\n$breakpoint-md: 900px;\n$breakpoint-extra-lg: 2048px;\n\n$nav-menu-width: 300px;\n$nav-menu-width-md: 250px;\n\n$nav-menu-mobile-height: 77px;\n$header-height: 68px;\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"nav-menu": `NavMenu_nav-menu__k2Ulv`,
	"items": `NavMenu_items__Avh8L`,
	"colabel": `NavMenu_colabel__bLn-f`,
	"item": `NavMenu_item__pv7QC`,
	"item-title": `NavMenu_item-title__FkWi1`,
	"is-active": `NavMenu_is-active__r3kd9`,
	"sign-out": `NavMenu_sign-out__1V6AD`,
	"powered": `NavMenu_powered__qkk61`,
	"header": `NavMenu_header__kkoKp`
};
export default ___CSS_LOADER_EXPORT___;
